/**
 * The model for the Retail /Currency/:id REST endpoint
 */
import RetailModel from 'app/src/data/models/RetailModel';
import URLHelper from 'app/src/data/models/utils/URLHelper';

export default class Currency extends RetailModel {
  get defaults() {
    return {
      code: '',
      symbol: '',
      decimalPrecision: 2,
    };
  }

  /**
   * Overridden to parse out the superfluous json that the LSCloud returns us
   * @param response - the json object returned from the fetch call before this object has initialized from it
   * @returns {*} the json object that this object will initialize itself from
   */
  parse(response) {
    let parsedResponse;
    // trim out wonky stuff from the response which is present if we fetch a single model
    // but not if it's coming from a collection
    if (response.Currency) {
      parsedResponse = response.Currency;
    } else {
      parsedResponse = response;
    }

    return parsedResponse;
  }
}
